// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","label":"Button_label__2AAHL","rightIcon":"Button_rightIcon__X_ONZ"};